import { render, staticRenderFns } from "./stockTurn.vue?vue&type=template&id=526e25be&scoped=true&"
import script from "./stockTurn.vue?vue&type=script&lang=js&"
export * from "./stockTurn.vue?vue&type=script&lang=js&"
import style0 from "./stockTurn.vue?vue&type=style&index=0&id=526e25be&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e25be",
  null
  
)

export default component.exports